export class StringUtils
{
    //Extracts filename from full path
    public static filterFilename( path: string ): string
    {
        if (path.indexOf('\\') != -1 ) {
            let arr = path.split('\\');
            return arr[arr.length - 1];
        } else if (path.indexOf('/') != -1 ) {
            let arr = path.split('/');
            return arr[arr.length - 1];
        } else {
            return '';
        }
    }
}